export class PhotoViewerModel {
  constructor(public urls: string[], public photoIndex: number) {}
}
